import PropTypes from "prop-types";
import React, {useState} from 'react';
import duckify from "../../utils/duckify";
import registeredComponent from "../../utils/registeredComponent";
import {Creatable} from "react-select";
import {tags} from "../../ducks";

/**
 * Input component for editing the "tag_names" property of a Taggable model.
 *
 * @example usage in haml file
 *   = react_component('TagInput', {name: 'search[tag_names]', value: @search.tag_names})
 *
 * @param name the input name
 * @param {string[]} value the input value (array of strings)
 * @param {{name}[]} tags the available tags, injected by duckify
 * @returns {JSX.Element}
 */
const TagInput = ({name, value = [], tags}) => {
  const [selection, setSelection] = useState(value.map(t => ({value: t, label: t})));

  return <React.Fragment>
    <Creatable
      className="tag-input"
      multi
      onChange={selected => setSelection(selected)}
      options={tags.map(t => ({value: t.name, label: t.name}))}
      value={selection}
    />
    {selection.map(option =>
      <input key={option.value} type="hidden" name={`${name}[]`} value={option.value}/>
    )}
  </React.Fragment>;
};

TagInput.propTypes = {
  /** Input name, used to generate hidden inputs named "${name}[]" for tag selection  */
  name: PropTypes.string.isRequired,

  /** The value of the `tag_names` property */
  value: PropTypes.arrayOf(PropTypes.string)
};

const mapDucksToProps = () => ({tags});

export default registeredComponent("TagInput")(duckify(mapDucksToProps)(TagInput));
